import { useStore } from '../store';

export const setShareModalTimeline = (timelineId: string) => {
  useStore.setState({ shareModal: { timelineId: timelineId, memoryId: null } });
};
